import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo_horizontal.png'


const _withScopeId = n => (_pushScopeId("data-v-c22aed68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-container" }
const _hoisted_2 = { class: "reset-form" }
const _hoisted_3 = { class: "reset" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reset-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { class: "reset-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "form-label header" }, "Forgot your password ?", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " That's ok, it happens. Specify your email and click the button below. We will send you a new password to your email. You can change it any time in your account settings. ", -1))
const _hoisted_8 = { class: "submit-container" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, "Back to Login"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.email || _ctx.isLoading,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, "Reset password", 8, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}